import {
  trackMandatoryAccountForChina,
  trackMandatoryAccountForIndia,
} from 'actions/tracker/tracker';
import { setPayerInfoByUser } from 'actions/ui/ui';
import { MandatoryAccountModal } from 'components/MandatoryAccountModal/MandatoryAccountModal';
import { Nothing } from 'components/Nothing/Nothing';
import { useMandatoryAccountEligibility } from 'hooks/useMandatoryAccountEligibility/useMandatoryAccountEligibility';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from 'selectors/entities/user/user';
import { useDispatch } from 'store/configureStore';

const MandatoryAccount = () => {
  const dispatch = useDispatch();
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const { email: userEmail } = useSelector(getUser);

  const { eligibility, testVariants, isFetching } =
    useMandatoryAccountEligibility();

  const activeModal =
    (eligibility.india && testVariants.india === 'B') ||
    (eligibility.china && testVariants.china === 'B');

  const userDataAvailable = isSignUpSuccess && userEmail;

  const handleSignUpSuccess = useCallback(() => {
    setIsSignUpSuccess(true);
  }, []);

  useEffect(() => {
    if (userDataAvailable) {
      dispatch(setPayerInfoByUser());
      setIsSignUpSuccess(false);
    }
  }, [userDataAvailable, dispatch]);

  useEffect(() => {
    if (!isFetching) {
      if (eligibility.india) {
        dispatch(trackMandatoryAccountForIndia(testVariants.india));
      }
      if (eligibility.china) {
        dispatch(trackMandatoryAccountForChina(testVariants.china));
      }
    }
  }, [isFetching, eligibility, testVariants, dispatch]);

  return activeModal ? (
    <MandatoryAccountModal onSignUpSuccess={handleSignUpSuccess} />
  ) : (
    <Nothing />
  );
};

export { MandatoryAccount };
